<h1 mat-dialog-title>
  Print settings
  <button
    (click)="cancel()"
    class="close-btn"
    data-test-id="print-settings-dialog-closeButton"
    isIconButton="true"
    mat-button
    type="button"
  >
    <mat-icon svgIcon="close"></mat-icon>
  </button>
</h1>
<div class="flex flex-col flex-start-start" mat-dialog-content>
  <span class="desc">Select layout options for the CV to be printed.</span>
  <div class="presenter-section ng-select-flex-content-wrapper">
    <ng-select
      [appendTo]="'.cdk-overlay-pane'"
      [clearable]="false"
      [closeOnSelect]="true"
      [disabled]="printSettings.PrintBranding === false"
      [items]="Presenters"
      [multiple]="false"
      [(ngModel)]="presenters.choosenPresenter"
      (change)="printSettings.PrintPresenterId = presenters.choosenPresenter.CrmId"
      bindLabel="Name"
      data-test-id="print-settings-dialog-chosenPresenter"
      placeholder="Select Presenter"
    ></ng-select>
    <label class="ng-select-label">Presented by</label>
  </div>
  <div class="flex flex-col flex-start-start">
    <div class="mat-checkbox-container">
      <mat-checkbox
        [ngModel]="!printSettings.PrintBranding"
        (ngModelChange)="printSettings.PrintBranding = !$event"
        color="primary"
        data-test-id="print-settings-dialog-PrintCvWithoutBranding"
      >
        Without 7N branding
      </mat-checkbox>
    </div>
    <div class="mat-checkbox-container">
      <mat-checkbox
        [ngModel]="!printSettings.PrintPhoto"
        (ngModelChange)="printSettings.PrintPhoto = !$event"
        color="primary"
        data-test-id="print-settings-dialog-PrintCvWithoutPhoto"
      >
        Without consultant photo
      </mat-checkbox>
    </div>
    <div class="mat-checkbox-container">
      <mat-checkbox
        [(ngModel)]="printSettings.PrintAnonymized"
        color="primary"
        data-test-id="print-settings-dialog-PrintCvAnonymized"
      >
        Anonymized
      </mat-checkbox>
    </div>
  </div>
</div>
<div mat-dialog-actions>
  <button
    [loading]="loading"
    (click)="save()"
    class="small-button"
    color="primary"
    data-test-id="print-settings-dialog-saveButton"
    mat-stroked-button
    type="submit"
  >
    Save settings
  </button>
  <button
    (click)="cancel()"
    class="small-button"
    color="primary"
    data-test-id="print-settings-dialog-cancelButton"
    mat-button
    type="button"
  >
    Cancel
  </button>
</div>
